import {
  CheckboxVisibility,
  DetailsList,
  Dropdown,
  IColumn,
  IContextualMenuItem,
  IDetailsRowProps,
  IIconProps,
  IStackStyles,
  PersonaSize,
  PrimaryButton,
  Stack,
  TextField,
} from '@fluentui/react';
import * as React from 'react';
import { MouseEvent } from 'react';
import { useTranslation } from 'react-i18next';
import Paging from '../../../control/paging';
import '../../../css/components/products.scss';
import useToken from '../../account/login/useToken';
import * as Api from '../../../api/src';
import ButtonMenuContext from '../../../control/ButtonMenuContext';
import { DialogContext } from '../../../context/dialog.context';
import ModalUser from '../../../components/settings/users/modal/modalUser';
import { commonfn } from '../../../common/commonfn';
import { _renderRow } from '../../../control/function/detailList';
import { NoDataFound } from '../../../control/noDataFound';
import { StatusItem } from '../../../control/statusItem';
import { Avatar } from '../../../control/avatar';
import { Loading } from '../../../control/loading';
import ModalResetPass from '../../../components/settings/users/modal/modalResetPass';

const UserApi = new Api.UserApi();
const VendorsApi = new Api.VendorsApi();
let FilterQueryCache = {
  PageNumber: 1,
  OrderBy: [{ ColumnName: 'Name' }],
  PageSize: 20,
  VendorId: 0,
} as Api.GetPagedUserQuery | null;
const Users = () => {
  const { setMsgConfirmDialog, setCallBackConfirmDialog, setTitleDialog } = React.useContext(DialogContext);
  const {} = useToken();
  const { t } = useTranslation();
  const [page, setPage] = React.useState(1);
  const _columns = [
    {
      key: 'action',
      name: '',
      isResizable: true,
      minWidth: 20,
      maxWidth: 20,
      onRender: (item: Api.User) => {
        let menuItems: IContextualMenuItem[] = [
          {
            key: 'Edit',
            text: t('Edit'),
            onClick: (ev) => {
              SetItemSelected(item);
              SetIsOpenModal(true);
            },
          },
          {
            key: 'Reset Password',
            text: t('ResetPassword'),
            onClick: (ev) => {
              SetItemSelected(item);
              SetIsResetPassModal(true);
            },
          },
          {
            key: 'Delete',
            text: t('Delete'),
            onClick: (ev) => {
              setMsgConfirmDialog(t('AreYouSureYouWantToDeleteThisData'));
              setCallBackConfirmDialog({ action: deleteItem, param: item.Id });
              console.log(item.Id);
            },
          },
        ];
        return <ButtonMenuContext ClassName={'menuContextDefault'} MenuItems={menuItems} IconName={'MoreVertical'} />;
      },
    },
    {
      key: 'FullName',
      name: t('FullName'),
      fieldName: 'FullName',
      className: 'flex-center',
      isResizable: true,
      minWidth: 300,
      onRender: (item: Api.UserDto) => {
        return (
          <Avatar
            text={item.FullName || ''}
            keyColor={(item.Id || 0).toString()}
            size={PersonaSize.size24}
            RandomColor={true}
          ></Avatar>
        );
      },
    },
    {
      key: 'Email',
      name: t('Email'),
      fieldName: 'Email',
      className: 'flex-center',
      maxWidth: 300,
      minWidth: 300,
    },
    {
      key: 'Company',
      name: t('Company'),
      fieldName: 'Company',
      className: 'flex-center',
      maxWidth: 300,
      minWidth: 300,
    },
    {
      key: 'Department',
      name: t('Department'),
      className: 'flex-center',
      maxWidth: 300,
      minWidth: 300,
      onRender: (item: Api.UserDto) => {
        return item.CompanyType === 'SallingGroup' ? item.Department : '-';
      },
    },
    {
      key: 'Status',
      name: t('Status'),
      className: 'flex-center',
      maxWidth: 100,
      minWidth: 100,
      onRender: (item: Api.UserDto) => {
        return (
          <StatusItem
            Status={item.States || Api.StatesEnum.Inactive}
            Name={t(commonfn.getActiveName(item.States))}
          ></StatusItem>
        );
      },
    },
  ] as IColumn[];
  const addIcon: IIconProps = { iconName: 'Filter' };
  const mailIcon: IIconProps = { iconName: 'Settings' };
  const stackStyles: Partial<IStackStyles> = { root: { height: 32 } };
  const [isOpenModal, SetIsOpenModal] = React.useState(false);
  const [isResetPassModal, SetIsResetPassModal] = React.useState(false);
  const [itemSelected, SetItemSelected] = React.useState<Api.Product | null>(null);
  const [listVendors, setListVendors] = React.useState<any[]>([]);
  const [FilterQuery, setFilterQuery] = React.useState<Api.GetPagedUserQuery>({
    PageNumber: 1,
    OrderBy: [{ ColumnName: 'Name' }],
    PageSize: 20,
    VendorId: 0,
  });
  // const [prevState, setPrevState] = React.useState<Api.GetPagedUserQuery>({
  //     PageNumber: 1, OrderBy: [{ ColumnName: "Name" }], PageSize: 20, VendorId: 0,
  // });
  const [listMaster, setListMaster] = React.useState<Api.UserDtoPaginatedResult | null>(null);
  const [isShowLoading, SetIsShowLoading] = React.useState(true);
  const [columns, setColumns] = React.useState<any[]>(_columns);

  const getList = async () => {
    SetIsShowLoading(true);
    let data = (await UserApi.apiUserPagedPost(FilterQuery)).data;
    setListMaster(data);
    setTimeout(() => {
      SetIsShowLoading(false);
    }, 500);
  };
  const deleteItem = async (id: number) => {
    let data = await UserApi.apiUserSetStatesPatch({ Id: id, States: Api.StatesEnum.Delete });
    setFilterQuery({ ...FilterQueryCache, PageNumber: 1 });
  };

  let timeOutGetList: any = null;
  React.useEffect(() => {
    if (FilterQueryCache?.SearchString !== FilterQuery.SearchString) {
      if (timeOutGetList) {
        clearTimeout(timeOutGetList);
        timeOutGetList = null;
      }
      timeOutGetList = setTimeout(() => {
        getList();
        timeOutGetList = null;
      }, 350);
      FilterQueryCache = FilterQuery;
      return () => window.clearTimeout(timeOutGetList);
    } else {
      getList();
      FilterQueryCache = FilterQuery;
    }
  }, [FilterQuery]);
  React.useEffect(() => {
    getAllVendors();
  }, []);
  const getAllVendors = async () => {
    if (listVendors.length > 0) return;
    let data = (
      await VendorsApi.apiVendorsPagedPost({
        PageNumber: 1,
        OrderBy: [{ ColumnName: 'Name' }],
        PageSize: 0,
        SearchString: '',
        GetOnlyActive: true,
      })
    ).data;
    let vendors: any[] = [
      { key: 0, text: t('AllUser') },
      { key: -1, text: t('SallingGroup') },
    ];
    data.Data?.forEach((element) => {
      vendors.push({ key: element.Id, text: element.Name });
    });
    setListVendors(vendors);
  };
  const _onColumnClick = (event: MouseEvent<HTMLElement> | undefined, column: IColumn | undefined) => {
    if (column?.name) {
      SetIsShowLoading(true);
      const newColumns: IColumn[] = columns.slice();
      const currColumn: IColumn = newColumns.filter((currCol) => column?.key === currCol.key)[0];
      newColumns.forEach((newCol: IColumn) => {
        if (newCol === currColumn) {
          currColumn.isSortedDescending = !currColumn.isSortedDescending;
          currColumn.isSorted = true;
        } else {
          newCol.isSorted = false;
          newCol.isSortedDescending = true;
        }
      });

      setFilterQuery({ ...FilterQuery, OrderBy: [{ ColumnName: column?.key, IsDesc: currColumn.isSortedDescending }] });
      setColumns(newColumns);
    }
  };
  return (
    <>
      <div className="page-content ">
        <Loading isShow={isShowLoading}></Loading>
        <div className="ms-Grid  form-list" dir="ltr">
          <div className="ms-Grid-row display-flex">
            <div className="ms-Grid-col padding-left-0  ms-md2" style={{ minWidth: 250 }}>
              <Dropdown
                options={listVendors}
                selectedKey={FilterQuery?.VendorId || 0}
                defaultSelectedKey={FilterQuery?.VendorId || 0}
                onChange={(e, opt, index) => {
                  setFilterQuery({ ...FilterQuery, VendorId: parseInt((opt?.key || 0).toString()), PageNumber: 1 });
                }}
              ></Dropdown>
            </div>
            <div className="ms-Grid-col padding-left-0 margin-right-auto ms-md2" style={{ minWidth: 250 }}>
              <TextField
                iconProps={{ iconName: 'search' }}
                placeholder={t('Search')}
                value={FilterQuery.SearchString || ''}
                onChange={(e, newValue) => {
                  setFilterQuery({ ...FilterQuery, SearchString: newValue || '', PageNumber: 1 });
                }}
              ></TextField>
            </div>
            <div className="ms-Grid-col ms-sm6">
              <Stack horizontal className="header-action">
                &nbsp; &nbsp;
                <PrimaryButton
                  text={t('New')}
                  className={'margin-left-auto'}
                  onClick={() => {
                    SetIsOpenModal(true);
                    SetItemSelected(null);
                  }}
                />
              </Stack>
            </div>
          </div>
        </div>
        <div className="ms-Grid-row">
          {(listMaster?.Data?.length || 0) > 0 && (
            <DetailsList
              items={listMaster?.Data || []}
              columns={columns}
              checkboxVisibility={CheckboxVisibility.hidden}
              onColumnHeaderClick={_onColumnClick}
              onRenderRow={(props) => {
                return _renderRow(props || ({} as IDetailsRowProps), () => {
                  //console.log(props)
                  //if (props && props.item?.CompanyType === 'Vendor') {
                  SetItemSelected(props?.item);
                  SetIsOpenModal(true);
                  //}
                });
              }}
            />
          )}
          <NoDataFound isShow={listMaster?.Data?.length === 0}></NoDataFound>
          <Paging
            CurrentPage={FilterQuery.PageNumber}
            TotalPage={listMaster?.TotalPages || 0}
            onChangePage={(page, pageSize) => {
              setFilterQuery({ ...FilterQuery, PageNumber: page, PageSize: pageSize });
            }}
          ></Paging>
        </div>
      </div>
      <ModalUser
        IsOpen={isOpenModal}
        Item={itemSelected}
        onCloseModal={() => {
          SetIsOpenModal(false);
        }}
        onSaveClick={() => {
          setFilterQuery({ ...FilterQuery, PageNumber: 1 });
        }}
      ></ModalUser>
      <ModalResetPass
        IsOpen={isResetPassModal}
        Item={itemSelected}
        onCloseModal={() => {
          SetIsResetPassModal(false);
        }}
        onSaveClick={() => {
          setFilterQuery({ ...FilterQuery, PageNumber: 1 });
        }}
      ></ModalResetPass>
    </>
  );
};
export default Users;
